<style lang="scss" scoped>

    .myAmpleon .main .container {
        width: auto;
    }

    .myAmpleon .content {
        @media screen and (max-width: 767px) {
            margin-top: 0;
        }
    }

    h3.page-title {
        color: #000 !important;
        font-size: 24px;
        line-height: 29px;
    }

    .sidebar, .banner {
        display: none;
    }

    .content {
        left: 0;
        width: 100% !important;
    }

    .row__account-successful {
        min-height: 100vh;

        @media (max-width: 991px) {
            flex-direction: column-reverse;
            min-height: auto;
        }

        .parametric-intro {
            margin: 0;
        }

        .page-title {

            @media (max-width: 767px) {
                padding: 15px 0 !important;
            }
        }

        .image-section {

            @media (max-width: 991px) {
                height: 270px;
            }

            @media (max-width: 767px) {
                height: 402px;
            }
        }
    }

    .row--flex {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
    }

    .image-section {
        display: flex;
        flex-direction: column;
        font-family: "Open Sans", sans-serif;
        position: relative;
        background-image: url("../assets/images/register-img.jpg");
        background-position: center;
        -webkit-background-size: cover;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .overlay {
        opacity: 0.8;
        color: #fff;
        background: #003B71;
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
    }

    .svg-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        height: 170px;

        path {
            fill: #ffffff;
        }
    }

    .col-spacing-75 {
        padding: 0 75px;

        @media (max-width: 991px) {
            padding: 0 25px;
        }

        @media (max-width: 767px) {
            padding: 0 15px;
        }
    }

    .form-check-label {
        margin: 0 0 0 20px;
        font-size: 12px;
        font-weight: 300;
        line-height: 13px;
        transform: translateY(-2px);
    }

    .form-textarea {
        width: 100%;
    }

    .invalid-feedback {
        color: red;
        margin-left: 12px;
        margin-bottom: 0;
    }

    .account-intro {
        margin: 0;
        padding-top: 43px !important;
    }

    .label-forgot-pass {
        float: right;
        font-weight: bold;
    }

    .login-question {
        margin-bottom: 48px;
        font-weight: bold;
    }

    .login-button {
        padding-left: 35px;
        padding-right: 35px;
    }

    .form-control {
        padding: 5px 18px;
        border-color: #ddd;
        box-shadow: none;
        font-size: 14px;
        line-height: 20px;

        &::-webkit-input-placeholder { /* Edge */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &::placeholder {
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }
    }

    .button-save {
        padding-left: 35px;
        padding-right: 35px;
    }

    .edit-button {
        padding: 0 5px;
        float: right;
        border-radius: 4px;
        border-color: #FFFFFF;
        background-color: #FFFFFF;
    }


    .list-group-item-heading {
        padding: 7px 5px;

        .edit-button:hover {
            border-color: #FFFFFF;
            background-color: #FFFFFF;
        }
    }


    .label-account {
        font-weight: bold;
    }

    .item-wrap {
        display: flex;
        align-items: center;
    }

    .label-account {
        flex: 1;
    }

    .list-wrap {
        flex: 4;
    }

    .list-group-item {
        border: 0;
    }

    .fa-pencil {
        color: #46b8da;
    }

    .edit-wrap {
        cursor: pointer;
    }

    .iterate-wrap:nth-child(3) {
        i {
            display: none;
        }
    }

    .info-header {
        margin-bottom: 30px;
    }

    .admin-link {
        font-weight: bold;
        font-size: 12px;
        line-height: 13px;
    }

    .icon-input-wrap {
        position: relative;

        .fa-pencil {
            position: absolute;
            right: 2%;
            bottom: 11px;
        }
    }
</style>

<template>
    <div class="account-wrapper">
        <top-bar active-item="account"/>
        <div class="row row--flex row__account-successful">
            <div class="col-md-6 col-spacing-75">
                <div class="account-intro">
                    <h3 class="page-title">My Account</h3>
                </div>

                <form @submit.prevent="handleSubmit">
                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <h4 class="info-header">Personal Information</h4>
                            <Alert v-if="submitted  && alertSuccess" message="Success: Changes are successfully saved"
                                   color="green"></Alert>
                            <Alert v-if="submitted && alertError"
                                   message="Failure: Something went wrong while saving the account changes. Please try again later."
                                   color="red"></Alert>

                            <ul class="list-group">

                                <div class="item-wrap">
                                    <label class="label-account">First Name</label>
                                    <div class="list-wrap">
                                        <li class="list-group-item">
                                            <div class="icon-input-wrap">
                                                <input type="text"
                                                       v-model="user.firstName"
                                                       class="form-control" id="firstName"
                                                       :class="{ 'is-invalid': submitted && $v.user.firstName.$error }">
                                                <i class="fa fa-pencil"></i>
                                            </div>

                                            <p v-if="submitted && !$v.user.firstName.required" class="invalid-feedback">
                                                First name is required.</p>
                                        </li>
                                    </div>
                                </div>

                                <div class="item-wrap">
                                    <label class="label-account">Last Name</label>
                                    <div class="list-wrap">
                                        <li class="list-group-item">
                                            <div class="icon-input-wrap">
                                                <input type="text"
                                                       v-model="user.lastName"
                                                       class="form-control" id="lastName"
                                                       :class="{ 'is-invalid': submitted && $v.user.lastName.$error }">
                                                <i class="fa fa-pencil"></i>
                                            </div>

                                            <p v-if="submitted && !$v.user.lastName.required" class="invalid-feedback">
                                                Last name is required.</p>
                                        </li>
                                    </div>
                                </div>

                                <div class="item-wrap">
                                    <label class="label-account">Email</label>
                                    <div class="list-wrap">
                                        <li class="list-group-item">
                                            <input disabled="true"
                                                   type="text"
                                                   v-model="user.email"
                                                   class="form-control"
                                                   id="inputEmail">
                                        </li>
                                    </div>
                                </div>

                                <div class="item-wrap">
                                    <label class="label-account">Company Name</label>
                                    <div class="list-wrap">
                                        <li class="list-group-item">
                                            <div class="icon-input-wrap">
                                                <input type="text"
                                                       v-model="user.company"
                                                       class="form-control"
                                                       id="company"
                                                       :class="{ 'is-invalid': submitted && $v.user.company.$error }">
                                                <i class="fa fa-pencil"></i>
                                            </div>
                                            <p v-if="submitted && !$v.user.company.required"
                                               class="invalid-feedback">Company name is required.</p>
                                        </li>
                                    </div>
                                </div>

                                <div class="item-wrap">
                                    <label class="label-account">Business Title</label>
                                    <div class="list-wrap">
                                        <li class="list-group-item">
                                            <div class="icon-input-wrap">
                                                <input type="text"
                                                       v-model="user.businessTitle"
                                                       class="form-control"
                                                       id="business"
                                                       :class="{ 'is-invalid': submitted && $v.user.businessTitle.$error }">
                                                <i class="fa fa-pencil"></i>
                                            </div>
                                            <p v-if="submitted && !$v.user.businessTitle.required"
                                               class="invalid-feedback">Business title is required.</p>
                                        </li>
                                    </div>
                                </div>

                                <div class="item-wrap">
                                    <label class="label-account">Phone</label>
                                    <div class="list-wrap">
                                        <li class="list-group-item">
                                            <div class="icon-input-wrap">
                                                <input type="text"
                                                       v-model="user.phone"
                                                       class="form-control"
                                                       id="phone">
                                                <i class="fa fa-pencil"></i>
                                            </div>
                                        </li>
                                    </div>
                                </div>

                                <div class="item-wrap">
                                    <label class="label-account">Country</label>
                                    <div class="list-wrap">
                                        <li class="list-group-item">
                                            <input disabled="true" type="text" v-model="user.country.name"
                                                   class="form-control" id="country">
                                        </li>
                                    </div>
                                </div>

                                <div class="item-wrap">
                                    <label class="label-account">Password</label>
                                    <div class="list-wrap">
                                        <li class="list-group-item">
                                            <PasswordFieldWithStrengthMeter
                                                v-model="user.password"
                                                :email="user.email"
                                                :submitted="submitted && showConfirmPass"
                                                :include-password-history="true"
                                                @keyup.native="checkCapsLock"
                                                @mousedown.native="checkCapsLock"
                                                @click.native="showConfirmPass = true"
                                                @valid="validatePasswordHistory"
                                            >
                                            </PasswordFieldWithStrengthMeter>
                                            <p v-if="capsLockWarning" class="invalid-feedback">Warning: Caps lock is
                                                on.</p>
                                        </li>
                                    </div>
                                </div>


                                <div class="item-wrap" v-show="showConfirmPass">
                                    <label class="label-account">Confirm password</label>
                                    <div class="list-wrap">

                                        <li class="list-group-item">
                                            <input type="password" v-model="user.confirmPassword" class="form-control"
                                                   placeholder="Confirm Password"
                                                   @keyup="checkCapsLock"
                                                   @mousedown="checkCapsLock"
                                                   :class="{ 'is-invalid': submitted && showConfirmPass && $v.user.confirmPassword.$error }">
                                            <div v-if="submitted && showConfirmPass && $v.user.confirmPassword.$error"
                                                 class="invalid-feedback">
                                                <p v-if="showConfirmPass && !$v.user.confirmPassword.sameAsPassword">
                                                    Passwords don't match. Please try again.</p>
                                            </div>
                                        </li>
                                    </div>
                                </div>

                                <div class="item-wrap">
                                    <label class="label-account">Job Description</label>
                                    <div class="list-wrap">
                                        <li class="list-group-item">
                                            <select id="job" v-model="user.jobDescription" class="form-control">
                                                <
                                                <option style="white-space: pre-line;" disabled hidden>
                                                    {{user.jobDescription }}
                                                </option>
                                                <option value="" disabled hidden>Job Description *</option>
                                                <option value="Academic-Professor">Academic-Professor</option>
                                                <option value="Academic-Student">Academic-Student</option>
                                                <option value="Distribution">Distribution</option>
                                                <option value="Engineer-Applications">Engineer - Applications</option>
                                                <option value="Engineer-Component/Product">Engineer -
                                                    Component/Product
                                                </option>
                                                <option value="Engineer-Design">Engineer - Design</option>
                                                <option value="Engineer-Firmware">Engineer - Firmware</option>
                                                <option value="Engineer-Hardware">Engineer - Hardware</option>
                                                <option value="Engineer-Software">Engineer - Software</option>
                                                <option value="Engineer-System">Engineer - System</option>
                                                <option value="Engineer-System Architect">Engineer - System Architect
                                                </option>
                                                <option value="Engineer-Manufacturing/Process">
                                                    Engineer-Manufacturing/Process
                                                </option>
                                                <option value="Field Application Engineer">Field Application Engineer
                                                </option>
                                                <option value="Marketing">Marketing</option>
                                                <option value="Program/Project Manager">Program/Project Manager</option>
                                                <option value="Purchasing/Supply Management">Purchasing/Supply
                                                    Management
                                                </option>
                                                <option value="Quality">Quality</option>
                                                <option value="Sales">Sales</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </li>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <button type="submit"
                                    class="btn btn-primary button-save">Save
                            </button>
                        </div>
                    </div>

                </form>

                <div class="row form-row">
                    <div class="form-group col-md-12">
                        <router-link :to="{path: '/my-subscription'}" class="admin-link">Click here to change
                            subscription preferences
                        </router-link>
                    </div>
                </div>

                <div class="row form-row">
                    <div class="form-group col-md-12">
                        <a v-if="!isAdmin" class="admin-link" style="cursor: pointer" data-toggle="modal"
                           data-target="#deleteAccountModal">Delete your account</a>
                    </div>
                </div>
            </div>

            <div class="col-md-6 image-section">
                <div class="overlay">
                    <div class="svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 302 172" style="enable-background:new 0 0 302 172;" xml:space="preserve">
                            <path fill="#ffffff" class="st0" d="M151,0.9c21.6,0,31.3,11,34.8,38.1L198,139.2c1,8.1,1.9,9.3,5.8,9.3c3.3,0,4.4-1.2,5.4-9.3l12.2-100.1
                                c3.3-27.2,13.7-38.1,34.8-38.1c23,0,33.4,11,35.4,38.1l9.1,120c0.8,9.5-1.7,12-11.2,12h-3.9c-9.5,0-12-2.3-12.6-12l-8.3-119.8
                                c-0.8-11.2-3.1-14.1-9.1-14.1c-5.2,0-7.9,2.9-9.1,14.1l-14.1,104.3c-2.9,20.5-9.1,27.6-28.8,27.6c-17.4,0-25.9-6.8-28.8-27.6
                                L160.5,39.3c-1.2-11.2-3.9-14.1-9.3-14.1h-0.4c-5.4,0-8.1,2.9-9.3,14.1l-14.3,104.3c-2.9,20.7-11.4,27.6-28.8,27.6
                                c-19.7,0-25.9-7-28.8-27.6L55.5,39.3c-1.2-11.2-3.9-14.1-9.1-14.1c-6,0-8.3,2.9-9.1,14.1l-8.3,119.8c-0.8,9.5-3.1,12-12.6,12h-3.9
                                c-9.5,0-12-2.3-11.2-12l9.1-120C12.3,11.9,22.7,0.9,45.7,0.9c20.9,0,31.3,11,34.8,38.1l12.2,100.1c1,8.1,2.1,9.3,5.4,9.3
                                c3.9,0,4.8-1.2,5.8-9.3l12.2-100.1C119.7,11.7,129.4,0.9,151,0.9z"/>
                        </svg>
                    </div>
                </div>
            </div>
            <DeleteAccountModal/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import TopBar from "./TopBar";
    import {UserService} from "@/common/api.service";
    import {UPDATE_USER, FINALIZE_ACTION} from "@/store/actions.type";
    import {mapAsyncGetters, STATUS} from "@/store/utils/async";
    import {required, sameAs,} from "vuelidate/lib/validators";
    import Alert from "./Alert";
    import DeleteAccountModal from "./DeleteAccountModal";
    import PasswordFieldWithStrengthMeter from "@/components/PasswordFieldWithStrengthMeter";

    const customPassword = value => {
        return /^(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?!.*\s).{6,}$/.test(value)
    };

    export default {
        name: "MyAccount",
        components: {
            TopBar,
            Alert,
            DeleteAccountModal,
            PasswordFieldWithStrengthMeter
        },
        data() {
            return {
                alertError: false,
                alertSuccess: false,
                user: {
                    firstName: "",
                    lastName: "",
                    email: "",
                    password: "",
                    confirmPassword: "",
                    company: "",
                    phone: "",
                    jobDescription: "",
                    businessTitle: "",
                    country: ""
                },

                submitted: false,
                editOffset: -1,
                editPost: {},
                editPostOri: {},
                showConfirmPass: false,
                capsLockWarning: false,
                validPasswordHistory: false
            };
        },

        validations: {
            user: {
                firstName: {required},
                lastName: {required},
                email: {required},
                password: {
                    customPassword
                },
                confirmPassword: {sameAsPassword: sameAs('password')},
                company: {required},
                jobDescription: {required},
                businessTitle: {required}
            }
        },

        computed: {
            ...mapAsyncGetters(UPDATE_USER),
            ...mapGetters(["isAdmin"]),
            getUser: function () {
                return this.$store.getters.user;
            }
        },

        watch: {
            status: function (newValue) {
                if (this.isFinished) {
                    if (newValue === STATUS.SUCCESS) {
                        this.alertSuccess = true;
                    } else if (newValue === STATUS.FAILURE) {
                        this.alertError = true;
                    }
                }
            }
        },

        async mounted() {
            await UserService.getUserAccount(this.getUser.email)
                .then(({data}) => {
                    this.user = data;
                });
        },
        methods: {
            validatePasswordHistory(valid) {
                this.validPasswordHistory = valid;
            },
            handleSubmit() {
                // stop here if form is invalid
                this.$v.$touch();
                this.submitted = true;
                if (this.$v.$invalid || !this.validPasswordHistory) {
                    if (!this.showConfirmPass
                        && !this.$v.user.firstName.$invalid
                        && !this.$v.user.lastName.$invalid

                        && !this.$v.user.company.$invalid
                        && !this.$v.user.businessTitle.$invalid
                        && !this.$v.user.jobDescription.$invalid
                    ) {
                        let payload = Object.assign({}, this.user);
                        payload.password = undefined;
                        this.$store.dispatch(UPDATE_USER, payload)
                            .then(() => this.$store.dispatch(FINALIZE_ACTION, UPDATE_USER));
                    }
                } else {
                    this.$store.dispatch(UPDATE_USER, this.user)
                        .then(() => this.$store.dispatch(FINALIZE_ACTION, UPDATE_USER));
                }
            },
            checkCapsLock(e) {
                this.capsLockWarning = e.getModifierState('CapsLock') === true;
            }
        }
    };
</script>

